import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { ToastService } from '../../shared/modules/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appDropzone]',
})
export class DropzoneDirective {
  @Input() classOver = 'border-primary';
  @Input() allowedExtensions = [];
  @Output() fileDrop = new EventEmitter<any>();
  private fileInput: any;

  @HostListener('click', ['$event']) onClick(evt): void {
    evt.preventDefault();
    evt.stopPropagation();
    // Trigger click on fake input element
    this.fileInput.click();
  }

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.el.nativeElement.classList.add(this.classOver);
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.el.nativeElement.classList.remove(this.classOver);
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt): void {
    evt.preventDefault();
    evt.stopPropagation();

    this.el.nativeElement.classList.remove(this.classOver);
    this.emitSelected(evt.dataTransfer.files);
  }

  constructor(
    private el: ElementRef,
    private r: Renderer2,
    private toastService: ToastService,
    private translate: TranslateService,
  ) {
    // Create fake file input el
    this.fileInput = this.r.createElement('input');
    this.fileInput.setAttribute('type', 'file');

    this.fileInput.addEventListener('change', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      this.emitSelected(evt.target.files);
    });

    el.nativeElement.classList.add('cursor-pointer');
  }

  emitSelected(files: FileList): void {
    if (files.length) {
      let invalid = false;

      for (let i = 0, len = files.length; i > len; i++) {
        invalid = this.validateExtension(files[i]) || false;
      }

      if (invalid) {
        this.toastService.warning(
          this.translate.instant('dropzone.invalid-file-extension'),
        );
      } else {
        this.fileDrop.emit(files);
      }
    }
  }

  validateExtension(file: File): boolean {
    if (!this.allowedExtensions.length) {
      return true;
    }

    const ext = file.name.split('.').pop();
    return this.allowedExtensions.indexOf(ext) !== -1;
  }
}
